import { forwardRef, PropsWithChildren } from "react";
import { MobileHeaderProps } from "./types";
import { BackButton } from "@/components";
import styles from "./styles.scss";
import clsx from "clsx";
import { MobileHeaderVariant } from "./constants";

export const MobileHeader = forwardRef<
  HTMLElement,
  PropsWithChildren<MobileHeaderProps>
>(
  (
    {
      className,
      children,
      variant = MobileHeaderVariant.White,
      isBorderHidden,
      onBackButtonClick,
    },
    ref,
  ) => (
    <div
      className={clsx(
        styles.mobileHeaderWrapper,
        styles[variant],
        isBorderHidden && styles.borderHidden,
        className,
      )}
    >
      <header className={styles.header} ref={ref}>
        {onBackButtonClick && <BackButton onClick={onBackButtonClick} />}

        {children}
      </header>
    </div>
  ),
);
